import React from 'react';
import { QueryRenderer } from 'react-relay';
import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import RelayStore from './RelayStore';

const styles = {
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  error: {
    padding: 20,
  },
};

const RelayError = ({ error, retry }) => (
  <div style={styles.error}>
    {error.message}
    <br />
    <RaisedButton label="Retry" primary onClick={retry} />
  </div>
);

export default ({ container: Container, query, variables = {}, ...rest }) => (
  <QueryRenderer
    environment={RelayStore.store}
    query={query}
    variables={variables}
    render={({ error, retry, props }) => {
      if (error) {
        return <RelayError error={error} retry={retry} />;
      } else if (props) {
        return <Container {...rest} {...props} variables={variables} />;
      }

      return (
        <div style={styles.loading}>
          <CircularProgress size={40} />
        </div>
      );
    }}
  />
);



// WEBPACK FOOTER //
// ./src/relay/RelayRenderer.js